import { render, staticRenderFns } from "./modalDesbloqueioHorarios.vue?vue&type=template&id=c37d9054"
import script from "./modalDesbloqueioHorarios.vue?vue&type=script&lang=js"
export * from "./modalDesbloqueioHorarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports